import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

export type ParentButtonVariant =
  | 'primary'
  | 'success'
  | 'ghost'
  | 'icon'
  | 'text-ghost'
  | 'text-danger';

@Component({
  selector: 'app-parent-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './parent-button.component.html',
  styleUrl: './parent-button.component.scss',
  host: {
    '[class.parent-btn-host--block]': 'fullWidth()',
  },
})
export class ParentButtonComponent {
  variant = input<ParentButtonVariant>('primary');
  type = input<'button' | 'submit'>('button');
  loading = input(false);
  disabled = input(false);
  fullWidth = input(false);
  spread = input(false);
  clicked = output<Event>();

  onClick(event: Event): void {
    if (this.disabled() || this.loading()) {
      return;
    }
    this.clicked.emit(event);
  }
}
